module.exports = new __parcel__URL__("longincap.9e7d1e38.png").toString();